import React from 'react';

import {
  Flex, HStack, Text, useToast,
} from '@chakra-ui/react';
import { useMutation } from 'react-query';
import { useParams } from 'react-router-dom';

import api from 'api';
import {
  Button, Menu, Icon, StatusBadge,
} from 'components';
import { breadcrumbs } from 'constants/routes';
import BreadcrumbMenu from 'containers/Breadcrumb';
import useRouteStore from 'stores/useRoute';

import { ContentRoutes } from '../../enums/routes';

interface MetaProps {
  executionId: number | null
  executions: {
    label: string
    id: number | null
    onClick: () => void
  }[]
  onEdit: () => void
  isEditable?: boolean
}
export default function Meta({
  executionId, executions, onEdit, isEditable,
}:MetaProps) {
  const { id } = useParams<GeneralRoute>();
  const { route } = useRouteStore();
  const toast = useToast();

  const {
    mutate,
    isLoading,
  } = useMutation(() => api().get('report', {
    params: {
      id: executionId,
    },
  }), {
    onSuccess: ({ data }) => {
      toast({
        title: 'Gerado com sucesso!',
        description: 'O relatório foi gerado com sucesso!',
        status: 'success',
        duration: 5000,
        position: 'top-right',
        isClosable: true,
      });
      window.open(data);
    },
    onError: ({ errors }: {errors: any[]}) => {
      toast({
        title: 'Ocorreu um erro!',
        description: errors?.map(({ message }) => message),
        status: 'error',
        duration: 5000,
        position: 'top-right',
        isClosable: true,
      });
    },
  });

  return (
    <>
      <BreadcrumbMenu paths={[
        ...breadcrumbs[ContentRoutes.Routes], {
          path: `/${ContentRoutes.Routes}/${id}`,
          label: route.name,
        },
      ]}
      />
      <Flex
        align="center"
        justify="space-between">
        <Flex
          align="center"
          mt={2}>
          <Text
            whiteSpace="nowrap"
            textOverflow="ellipsis"
            overflow="hidden"
            maxW="30%"
            variant="3xLargeRegular"
            color="gray.700">{route?.code}
          </Text>
          <Text
            mx={1}
            mb={1}
            variant="3xLargeRegular"
            color="gray.700">|
          </Text>
          <Text
            whiteSpace="nowrap"
            textOverflow="ellipsis"
            overflow="hidden"
            maxW="40%"
            variant="3xLargeBold"
            color="gray.700">{route?.name}
          </Text>
          <StatusBadge
            label={route?.status?.toLocaleUpperCase()}
            ml={5}
            h="22px"
            status={route?.status}
          />
        </Flex>
        <HStack>
          {executionId && (
          <Button
            mr={4}
            onClick={() => mutate()}
            isLoading={isLoading}
            h={8}
            borderRadius={50}
            _hover={{ bg: 'gray.200' }}
            bg="white">
            <HStack>
              <Text
                variant="xSmallBold"
                color="gray.500">
                Gerar relatório
              </Text>
              <Icon
                color="gray.500"
                name="file-excel"
              />
            </HStack>
          </Button>
          )}
          {isEditable && (
          <Button
            onClick={onEdit}
            bg="white.default"
            borderRadius={50}
            h={8}
            _hover={{
              bg: 'primary.700',
              color: 'white.default',
            }}
            _active={{
              color: 'white.default',
            }}
            color="gray.500">
            <Text variant="xSmallSemiBold">Editar</Text><Icon
              ml={2}
              name="edit"
            />
          </Button>
          )}
          <Menu
            w="170px"
            size="sm"
            withIcon
            icon={{
              name: 'history',
              family: 'far',
            }}
            py={2}
            placeholder="Histórico de frequência"
            selected={executionId}
            options={executions}
          />
        </HStack>
      </Flex>
    </>
  );
}
